(function ($) {
  'use strict';

  function bindQuickAdd() {
    $(document).off('submit.smProductTile', '.sm-product-tile__quick-add-form, .sm-complementary-product__form');
    $(document).on('submit.smProductTile', '.sm-product-tile__quick-add-form, .sm-complementary-product__form', function (e) {
      e.preventDefault();

      var form = this;
      var $btn = $(form).find('.sm-product-tile__quick-add, .sm-complementary-product__cta');
      $btn.prop('disabled', true);

      if (typeof ShopifyAPI === 'undefined') {
        form.submit();
        return;
      }

      ShopifyAPI.addItemFromForm(form, function () {
        if (window.ajaxCart && ajaxCart.load) {
          ajaxCart.load();
        } else {
          ShopifyAPI.getCart(function (cart) {
            $(document.body).trigger('afterCartLoad.ajaxCart', cart);
          });
        }
        $btn.prop('disabled', false);
      }, function () {
        $btn.prop('disabled', false);
      });
    });
  }

  $(document).ready(bindQuickAdd);
  document.addEventListener('shopify:section:load', bindQuickAdd);
})(jQuery);
